module.exports = __webpack_public_path__ + "img/body-2.e4a3dad1.png";